import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { Setting } from "src/app/service/settings.service";
import { AbstractController } from "./abstract-controller";
import { Environment } from "../environment";

export class SettingsController extends AbstractController {
  private readonly service: string = "api/v1.0/admin";
  private readonly apiUrl: keyof Environment = "bwApiUrl";

  public async getAll(): Promise<Setting[]> {
    return await this.network.get(`${this.service}/settings`, this.apiUrl);
  }

  public async patchValue(setting_id:string, body:any){
    return await this.network.put(`${this.service}/settings/${setting_id}`, body, this.apiUrl);
  }

  /**
   * @param liste
   * @returns boolean
   *
   * Validator for forms; checking if the value entered does'nt already exist in the list
   */
  public notExistValidator(liste: string[] | undefined): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value

      let exist: boolean = true
      if (liste)
        for (let elem of liste) {
          if (elem === value) {
            exist = false
          }
        }

      return !exist ? { exist: true } : null
    }
  }

  /**
   * Validator for not have only whitespace on the value entered
   *
   * exemple : "  " is not accepted
   *
   * @returns boolean
   */
  public noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = control.value?.trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { whitespace: true };
    }
  }

  // JBE multi field control, unique check appplicationName+OS
  public  checkMultifield(fieldName1: string, fieldName2: string, liste: string[] | undefined):
  ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      const fieldValue1 = control.get(fieldName1)?.value;
      const fieldValue2 = control.get(fieldName2)?.value;
      const value =fieldValue1+fieldValue2;

      let exist: boolean = true
      if (liste)
        for (let elem of liste) {
          if (elem === value) {
            exist = false
          }
        }
      control.get(fieldName1)?.setErrors(!exist ? { exist: true } : null);
      return !exist ? { exist: true } : null

    }
  }
}

